var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"divide-y divide-gray-200",attrs:{"role":"list"}},_vm._l((_vm.data),function(item,index){return _c('li',{key:_vm.itemKey ? item[_vm.itemKey] || index : index},[_vm._t("default",null,{"index":index,"item":item})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }